import { useRef, useCallback } from 'react';

const useDataCache = () => {
  const cache = useRef({});

  const save = useCallback((data) => {
    cache.current = {
      ...cache.current,
      ...data,
    };
  }, []);

  const get = useCallback(() => cache.current, []);

  const has = useCallback(() => Object.keys(cache.current).length > 0, []);

  return {
    save,
    get,
    has,
  };
};

export default useDataCache;
